import cx from 'classnames';
import React, { useState, useEffect } from 'react';
import { Dropdown } from "react-bootstrap";
import { Navbar, Nav, NavItem } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchAllDataApi, getLatestMessages, getUnseenNotifications } from '../../services/notifications';
import { CiLogout } from "react-icons/ci";
import { FaRegArrowAltCircleLeft, FaRegArrowAltCircleRight, FaRegBell } from "react-icons/fa";
//import { getWebSocket } from '../../socket-setup';
import { seenNotification } from '../../services/notifications';
import PopoverNotification from './poppupNotification';
import './Header.css';
import i18n from '../../i18n';
import { FiAlignJustify, FiSearch } from 'react-icons/fi';

import { FaTable, FaBullhorn, FaUniversity, FaUsers, FaCertificate } from 'react-icons/fa';
import { IoHomeOutline } from "react-icons/io5";
import { TbReportAnalytics } from 'react-icons/tb'
import { Ticket } from 'react-bootstrap-icons'
import { PiCertificate } from 'react-icons/pi'

interface Notification {
  id: number;
  message: string;
  functionsAll: string;
  createdAt: Date;
  seen: boolean;
}

interface HeaderProps {
  onMobileToggle: () => void
  toggleSidebar?: () => void
  className?: string
}

const Header: React.FC<HeaderProps> = ({ onMobileToggle, toggleSidebar, className }) => {
  const { t } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const navigate = useNavigate();
  const [isNotiOpen, setIsNotiOpen] = useState(false);
  const [unseenCount, setUnseenCount] = useState(0);
  const [latestNotification, setlatestNotification] = useState("");
  const [isMobileSearchVisible, setIsMobileSearchVisible] = useState(false);

  const seeNotification = async () => {
    try {
      const userId = localStorage.getItem("userId") || "";
      await seenNotification(userId);
      setUnseenCount(0);
      setIsNotiOpen(false);
    } catch (error) {
      console.error("Error marking notifications as seen:", error);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/login');
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        let userId = localStorage.getItem("userId");
        const total_count = await fetchAllDataApi(`notifications/unseen?userId=${userId}&query=${""}&perPage=${5}&pageNo=${0}`);
        const latestMessages = await getLatestMessages(`notifications/notifications-latest`);
        setlatestNotification(latestMessages?.data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchNotifications();
    getUnseenNotificationsData()
  }, []);

  const getUnseenNotificationsData = async () => {
    const userId = localStorage.getItem("userId") || "";
    const unseenNotifications = await getUnseenNotifications(userId);
    if(unseenNotifications.success){
      setUnseenCount(unseenNotifications.totalCount);
    } else {
      setUnseenCount(0);
    }
  };

  /*useEffect(() => {
    const socket = getWebSocket();
    if (socket) {
    //  socket.on('receiveNotification', (notification) => {
    //    setUnseenCount((prevCount) => prevCount + 1);
        getUnseenNotificationsData()
      });
    }
    return () => {
      if (socket) {
        socket.off('receiveNotification');
      }
    };
  }, []);*/

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLanguage);
    setCurrentLanguage(newLanguage);
    document.documentElement.setAttribute('dir', newLanguage === 'ar' ? 'rtl' : 'ltr');
  };

  const toggleMobileSearch = () => {
    setIsMobileSearchVisible(!isMobileSearchVisible);
  };
  const links = [
    { labelKey: 'Sidebar.Dashboard', href: '/', icon: <IoHomeOutline /> },
    { labelKey: 'Sidebar.Report', href: '/reports', icon: <TbReportAnalytics /> },
    { labelKey: 'Sidebar.Standards', href: '/standards', icon: <FaTable /> },
    { labelKey: 'Sidebar.Tickets', href: '/ticket', icon: <Ticket /> },
    { labelKey: 'Sidebar.Certifications', href: '/certifications', icon: <PiCertificate /> },
    { labelKey: 'Announcement', href: '/announcement', icon: <FaBullhorn /> },
    { labelKey: 'Sidebar.Institutions', href: '/institutions', icon: <FaUniversity /> },
    { labelKey: 'Sidebar.UserManagement', href: '/user', icon: <FaUsers /> },
  ];


  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);


  return (
    <Navbar className="root-header">
      {/* Sidebar toggle button (Visible only on md and up) */}
      <button 
        className="btn sidebar-toggle d-none d-md-flex" 
        onClick={onMobileToggle}
        aria-label={isSidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
      >
        {isSidebarOpen ? (
          <FaRegArrowAltCircleLeft size={24} />
        ) : (
          <FaRegArrowAltCircleRight size={24} />
        )}
      </button>
  
      {/* Mobile navigation dropdown without toggle button */}
      <div className="d-flex d-md-none align-items-center">
        <Dropdown>
          <Dropdown.Toggle 
            variant="link" 
            id="mobile-nav-dropdown"
            className="mobile-menu-button"
          >
            <span className="navbar-toggler-icon"></span>
          </Dropdown.Toggle>
  
          <Dropdown.Menu className="mobile-nav-menu">
  {links.map((link) => (
    <Dropdown.Item 
      key={link.href}
      onClick={() => {
        navigate(link.href);
        setIsMobileNavOpen(false);
      }}
      className="mobile-nav-item"
    >
      <div className="d-flex align-items-center">
        {link.icon} {t(link.labelKey)}
      </div>
    </Dropdown.Item>
  ))}
</Dropdown.Menu>

        </Dropdown>
      </div>
  
      {/* Search bar */}
      <div className={`search-container ${isMobileSearchVisible ? 'mobile-visible' : ''}`}>
        <Nav className="w-100">
          <NavItem className="w-75">
            <div className="inputSearch">
              <input
                type="text"
                placeholder={t('header.Search ....') || ''}
                className="form-control w-100 p-2 ps-4 bg-gray-100"
              />
            </div>
          </NavItem>
        </Nav>
      </div>
  
      {/* Mobile search toggle button */}
      <button 
        className="btn mobile-search-toggle d-md-none"
        onClick={toggleMobileSearch}
      >
        <FiSearch size={20} />
      </button>
  
      {/* Right side elements */}
      <div className="header-right-elements">
        {/* Notification */}
        <div className="notification-wrapper">
          <FaRegBell
            color="gray"
            size={20}
            className="hover-scale-110 cursor-pointer transition mt-2"
            onClick={() => setIsNotiOpen((s) => !s)}
          />
          {unseenCount > 0 && (
            <span className="notification-badge bg-danger pt-1">
              {unseenCount}
            </span>
          )}
          <PopoverNotification
            isOpen={isNotiOpen}
            onClose={() => setIsNotiOpen(false)}
            updateNotifications={seeNotification}
            notifications={latestNotification}
          />
        </div>
  
        {/* Language selector */}
        <button
          className="lang-switch d-flex align-items-center bg-transparent border-0 p-0"
          onClick={toggleLanguage}
        >
          <div className="language-flag">
            <img
              src={`/assets/images/${currentLanguage}.jpg`}
              alt={currentLanguage}
            />
          </div>
          <span className="d-none px-2 d-sm-inline">
            {currentLanguage === 'en' ? t('header.english') : t('header.arabic')}
          </span>
        </button>
  
        {/* Divider */}
        <div className="header-divider"></div>
  
        {/* Profile dropdown */}
        <Dropdown align="end" className="profile-dropdown">
          <Dropdown.Toggle as="div" className="profile-toggle">
            <img
              className="admin-photo mx-2"
              src="/assets/images/profile.png"
              alt="administrator"
            />
          </Dropdown.Toggle>
          
          <Dropdown.Menu>
            <Dropdown.Item onClick={handleLogout} className="logout-item">
              <CiLogout className="logout-icon" /> 
              <span>Logout</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </Navbar>
  );
  
}

export default Header;